module.exports = __webpack_public_path__ + "img/logo.d92afa44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 1